import './App.scss'
import {Suspense} from "react";
import {Route, Routes} from "react-router";
import Login from "./pages/login/Login.tsx";
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n.ts";
import './assets/styles/utilities.css';
import {ProtectedRoute} from "./protectedRoute/ProtectedRoute.tsx";
import {DefaultLayout} from "./layouts/DefaultLayout.tsx";
import {BrowserRouter} from "react-router-dom";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {ModalProvider} from "./context/ModalContext.tsx";
import {ModalContainer} from "./container/ModalContainer.tsx";
import 'react-datepicker/dist/react-datepicker.css';
import {LoaderComponent} from "./custom-components/loader/Loader.tsx";
import {NotFoundPage} from "./pages/notFound/NotFound.tsx";


function App() {
    // useTelegramDesktopMinWidth(820);

    return (
        <div className={"App"}>
            <Suspense fallback={<LoaderComponent/>}>
                <I18nextProvider i18n={i18n} defaultNS="translation">
                    <BrowserRouter>
                        <ModalProvider>
                            <Routes>
                                <Route path="/login" element={
                                    <Suspense fallback={<LoaderComponent/>}>
                                        <Login />
                                    </Suspense>
                                }/>

                                <Route path="/not_found" element={<NotFoundPage />} /> {/* <-- ВНЕ DefaultLayout */}

                                <Route path="/*" element={
                                    <Suspense fallback={<LoaderComponent/>}>
                                        <ProtectedRoute>
                                            <DefaultLayout />
                                        </ProtectedRoute>
                                    </Suspense>
                                }/>
                            </Routes>

                            <ModalContainer/>
                        </ModalProvider>
                    </BrowserRouter>
                </I18nextProvider>
            </Suspense>
        </div>

    )
}

export default App
